<template>
    <div class="countdown-text" :class="{ 'landscape': $mq === 'landscape', 'small': small }">
        <span class="countdown">{{ minutes }}:</span>
        <span class="small-text">{{ seconds }}</span>
    </div>
</template>

<script>
export default {
    props: {
        nextAlarm: Number,
        small: { type: Boolean, default: false }
    },
    data() {
        return {
            targetTime: null,
            startTime: null,
            days: '0',
            hours: '00',
            minutes: '00',
            seconds: '00',
            interval: null,
            isHoursMode: false,
            isDaysMode: false,
            isMoreThanSixHours: null,
            currentTime: Date.now()
        }
    },
    computed: {
        getTimeFilter() {
            const config = this.$store.getters['login/getConfig']
            return config.Timersh || config.Timersh > 0 ? config.Timersh : 6
        }
    },
    methods: {
        startCountdown() {
            this.targetTime = this.nextAlarm
            this.startTime = Date.now() // Guardamos el tiempo de inicio real
            this.updateCountdown()
            this.interval = setInterval(() => {
                this.updateCountdown()
            }, 1000)
        },

        updateCountdown() {
            this.currentTime = Date.now()
            const timeRemaining = this.targetTime - this.currentTime

            if (timeRemaining <= 0) {
                clearInterval(this.interval)
                this.days = '0'
                this.hours = '00'
                this.minutes = '00'
                this.seconds = '00'
                this.isHoursMode = false
                this.isDaysMode = false
                
                // Prevenir múltiples emisiones del evento timerCompleted
                if (!this._timerCompleted) {
                    this._timerCompleted = true
                    // Emitir evento cuando el timer termina
                    this.$emit('timerCompleted')
                }
                return
            }

            const totalSeconds = Math.floor(timeRemaining / 1000)
            const totalMinutes = Math.floor(totalSeconds / 60)
            const totalHours = Math.floor(totalMinutes / 60)

            const moreThanSixHours = totalHours >= this.getTimeFilter
            if (this.isMoreThanSixHours !== moreThanSixHours) {
                this.isMoreThanSixHours = moreThanSixHours
                this.emitTimeStatus(moreThanSixHours)
            }

            if (totalHours >= 24) {
                // Redondear hacia arriba solo si superamos las 23:59:59
                // const totalDays = Math.ceil(totalHours / 24)
                // this.isDaysMode = false
                // this.isHoursMode = false
                // this.days = String(totalDays) 
                this.isDaysMode = false
                this.isHoursMode = true
                this.hours = String(totalHours).padStart(2, '0')
                this.minutes = String(totalMinutes % 60).padStart(2, '0')
                this.seconds = String(totalSeconds % 60).padStart(2, '0')

            } else if (totalHours > 0) {
                // Muestra horas si hay más de 59 minutos y 59 segundos
                this.isDaysMode = false
                this.isHoursMode = true
                this.hours = String(totalHours).padStart(2, '0')
                this.minutes = String(totalMinutes % 60).padStart(2, '0')
                this.seconds = String(totalSeconds % 60).padStart(2, '0')
            } else {
                // Muestra minutos y segundos
                this.isDaysMode = false
                this.isHoursMode = false
                this.minutes = String(totalMinutes).padStart(2, '0')
                this.seconds = String(totalSeconds % 60).padStart(2, '0')
            }

            this.$emit('timeChanged', this.minutes, this.seconds)
        },

        emitTimeStatus(isMoreThanSixHours) {
            this.$emit('timeStatusChanged', isMoreThanSixHours)
        }
    },
    watch: {
        nextAlarm: {
            handler(newValue) {
                if (newValue) {
                    this.startCountdown()
                }
            },
            deep: true
        }
    },
    mounted() {
        if (this.nextAlarm) {
            this.startCountdown()
        }
    },
    beforeDestroy() {
        clearInterval(this.interval)
    }
}
</script>

<style lang="scss" scoped>

.countdown-text {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    line-height: normal;

    .countdown {
        font-family: $text-bold;
        @include font-size(32px);
    }

    .small-text {
        font-family: $text-bold;
        @include font-size(18px);
        margin-bottom: 4px;
    }

    &.small {
        .countdown {
            @include font-size(32px);
        }

        .small-text {
            @include font-size(24px);
            margin-bottom: 2px;
        }
    }

    /* PLS SIZES MONITORS*/
    &.landscape {
        .countdown {
            @include font-size(18px);
        }

        .small-text {
            @include font-size(14px);
            margin-bottom: 0px;
        }
    }
}



</style>
